import {
  ClientUser,
  adminAndAbove,
  basicUserAndAbove,
  getEffectiveProjectRole,
  hasProjectFullAccess,
  hasProjectReadAccess,
  roleIs
} from '@zerops/models/client-user';
import { AssignableProjectRole, Project, ProjectRoles } from '@zerops/models/project';

/**
 * Normalised to the two levels the UI renders, which keeps the `!== ProjectRoles.ReadOnly`
 * checks throughout the templates honest — an override the UI cannot assign (BASIC_USER,
 * NO_ACCESS) would otherwise slip through them as if it granted full access.
 */
export function getProjectRoleForUser(
  project: Project,
  currentUser: ClientUser
): AssignableProjectRole | null {
  if (hasProjectFullAccess(project, currentUser)) {
    return ProjectRoles.Admin;
  }

  if (hasProjectReadAccess(project, currentUser)) {
    return ProjectRoles.ReadOnly;
  }

  return null;
}

export function createRule(
  rule: { 'only': string[] } | { 'except': string[] } | { 'all': string[] },
  redirectTo?: any[]) {
  return {
    rule,
    redirectTo
  };
}

// A token can never exceed its creator's own access, so this is the creator's own
// effective role on the project, normalised to the assignable levels.
export function getMaxAssignableProjectRole(
  project: Project,
  currentUser: ClientUser
): AssignableProjectRole | null {
  if (roleIs(currentUser?.roleCode, ...adminAndAbove())) {
    return ProjectRoles.Admin;
  }

  const effectiveRole = getEffectiveProjectRole(project, currentUser);

  if (roleIs(effectiveRole, ...basicUserAndAbove())) {
    return ProjectRoles.Admin;
  }

  if (effectiveRole === ProjectRoles.ReadOnly) {
    return ProjectRoles.ReadOnly;
  }

  return null;
}
